import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import { Select, Input, Icon, Button, Tooltip, Popover, Descriptions, InputNumber } from 'antd';
import dragIcon from "../../../../../assets/svg/drag_icon.svg";
import openConfigIcon from "../../../../../assets/svg/ai-agents/FontAwsome (angle-double-left).svg";
import { ReactComponent as GeminiLogo } from '../../../../../assets/svg/ai-agents/geminiIcon.svg'
import { ReactComponent as ClaudeLogo } from '../../../../../assets/svg/ai-agents/claude-ai-icon.svg'
import { ReactComponent as GptLogo } from '../../../../../assets/svg/ai-agents/gptIcon.svg'
import { ReactComponent as UniphoreLogo } from '../../../../../assets/svg/sidemenu/uniphore_logo.svg'
import _ from "lodash";
import { ReactSortable } from "react-sortablejs";
const { Option } = Select;

type LlmConfig = {
    provider: string, model: string, config :{ topP: number, temperature: number, maxOutputTokens: number}
}

type LlmProps = {
    lock:boolean;
    setllmConfiguration: (val: LlmConfig) => void
    setOpenLLMConfig: (val: boolean) => void;
    llmConfiguration: LlmConfig
}

const Classifier = (props: any) => {/* eslint-disable */
    const { elements, nodeDetail, widgetDrawer, form } = props;
    const [sortableOptions, setSortableOptions] = useState({
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        ghostClass: "ghost",
        group: "shared",
        disabled: false,
        handle: ".drag-handle"
    });
    const llmConfig = {
        provider: "",
        model: "",
        config: {
            topP: 1,
            maxOutputTokens: 4000,
            temperature: 1
        }
    }
    const [classifierName, setClassifierName]: any = useState("")
    const [spaceKeyPressed, setSpaceKeyPressed]: any = useState(false)
    const [reactSortableKey, setReactSortableKey]: any = useState(new Date().getTime());
    const [addHandle, setAddHandle]: any = useState(0);
    const [addClassifier, setAddClassifier]: any = useState([{
        id: "",
        description: "",
        name: "",
        linkNode: "",
        nameCheck: false,
        blocks: false,
        expand: false,
    }])
    const [llmConfiguration, setllmConfiguration] = useState<LlmConfig>({
        provider: "",
        model: "",
        config: {      
            topP: 1,
            maxOutputTokens: 4000,
            temperature: 1
        }
    })
    const [nodes, setNodes]: any = useState(null)
    const [name, setName]: any = useState(null);
    const [openLLMConfig, setOpenLLMConfig] = useState<boolean>(false);
    const [inputQuery, setInputQuery]: any = useState(null);
    const [classifierProperty, setClassifierProperty]: any = useState({ nodeId: null })
    const [removeClassifier, setRemoveClassifier]: any = useState(0)
    const [removedLinkNode, setRemovedLinkNode]: any = useState(null);
    const [handleId, setHandleId]: any = useState(null)
    const [updatedId, setUpdatedId]: any = useState(null)
    const [showCheckIcon, setShowCheckIcon]: any = useState(false)
    const [showaddIcon, setShowAddIcon]: any = useState(false)
    const [value, setValue]: any = useState(null)
    const [showEdit, setshowEdit] = useState(true)
    const [toggle, setToggleEnable]: any = useState(false)
    const [expandAll, setExpandAll]: any = useState(false);
    const [disableExpand, setDisableExpand]: any = useState(true)
    const [removeValues, setRemoveValues]: any = useState(false)
    const [editEnable, setEditEnable]: any = useState(false)
    const [eventNameEmpty, setEventNameEmpty] = useState(false)
    const [selectedForm, setSelectedForm] = useState(null);
    const [formKey, setFormKey] = useState(null)

    useEffect(() => {
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        if (value && value.length > 0) {
            setShowCheckIcon(true)
        } else {
            setShowCheckIcon(false)
        }
    }, [value])

    useEffect(() => {
        let arr: any = [];
        let obj: any = {};
        if (addClassifier.length > 0) {
            const findSourceHandle = elements.map((el: any) => {
                if (el.hasOwnProperty("sourceHandle")) {
                    return { sourceHandle: el.sourceHandle, source: el.source, target: el.target };
                } else {
                    return ""
                }
            }).filter((el: any) => el)

            addClassifier.forEach((el: any) => {
                const element = findSourceHandle.filter((element: any) => { return element.sourceHandle === el.id && element.source === nodeDetail.id })
                let findElement: any;
                if (element.length > 0) {
                    element.forEach((e: any) => {
                        findElement = elements.filter((el: any) => { return el.id === e.target && e.source === nodeDetail.id })
                    })
                }
                if (findElement && findElement.length > 0) {
                    obj = {
                        ...el,
                        linkNode: findElement[0].id
                    }
                    arr.push(obj);
                } else {
                    obj = {
                        ...el,
                        linkNode: findElement && findElement.length === 0 ? el.linknode : ""
                    }
                    arr.push(obj)
                }
            })
        }
        arr.length > 0 && setAddClassifier(arr)
    }, [elements])

    useEffect(() => {
        if (nodeDetail && nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "aiClassifier") {
                if (nodeDetail.data.propertyDetails.classification) {
                    let arr: any = [];
                    let obj: any = {};
                    setClassifierName(nodeDetail.data.propertyDetails.name)
                    setName(nodeDetail.data.propertyDetails.name);
                    setInputQuery(nodeDetail.data.propertyDetails.inputQuery);
                    setDisableExpand(false)
                    setllmConfiguration(nodeDetail.data.propertyDetails?.llm || llmConfig)
                    setFormKey(nodeDetail.data.propertyDetails.formKey)
                    for (const element of elements) {
                        for (const classification of nodeDetail.data.propertyDetails.classification) {
                            if (element.source === nodeDetail.id && element.sourceHandle === classification.id) {
                                const nextNode = elements.filter((el: any) => { return (element.target === el.id) })
                                obj = {
                                    id: classification.id,
                                    name: classification.name,
                                    description: classification.description,
                                    linkNode: element.target,
                                    blocks: classification.blocks,
                                    nameCheck: classification.nameCheck,
                                    expand: classification.expand && classification.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    } else if (element.source === nodeDetail.id && element.sourceHandle === classification.id && classification.linkNode === "") {
                                        let value = arr.filter((ele: any) => {
                                            return ele.id === classification.id
                                        })
                                        value.map((val: any) => {
                                            val.linkNode = element.target;
                                        })
                                    }
                                } else {
                                    arr.push(obj);
                                }
                            } else if (classification.linkNode === "" && element.source !== nodeDetail.id && element.sourceHandle === undefined) {
                                obj = {
                                    id: classification.id,
                                    name: classification.name,
                                    description: classification.description,
                                    linkNode: classification.linkNode,
                                    blocks: classification.blocks,
                                    nameCheck: classification.nameCheck,
                                    expand: classification.expand && classification.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            } else {
                                const node = elements.filter((el: any) => { return nodeDetail.id === classification.linkNode })
                                obj = {
                                    id: classification.id,
                                    name: classification.name,
                                    description: classification.description,
                                    linkNode: node.length > 0 ? classification.linkNode : "",
                                    blocks: classification.blocks,
                                    nameCheck: classification.nameCheck,
                                    expand: classification.expand && classification.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            }
                        }
                    }

                    if (nodeDetail.data.propertyDetails.formKey) {
                        form && form.forEach((f: any) => {
                            if (f.formKey === nodeDetail.data.propertyDetails.formKey) {
                                setSelectedForm(f.displayName)
                            }
                        })
                    }

                    arr.length && setAddClassifier(arr)
                    setShowCheckIcon(true)
                    setRemoveValues(false)
                    setEditEnable(false)
                    setEventNameEmpty(false)
                    setShowAddIcon(true)
                } else {
                    if (nodeDetail.type === "aiClassifier") {
                        setName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.name);
                        setInputQuery(nodeDetail?.data?.propertyDetails?.inputQuery);
                        setClassifierName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.name);
                        setllmConfiguration(nodeDetail.data.propertyDetails?.llm)
                        setFormKey(nodeDetail.data.propertyDetails.formKey)
                        let classifierData: any = []
                        let classification: any = {}
                        let node: any;
                        let id = 0;
                        nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.classifications && nodeDetail.data.propertyDetails.classifications.map((c: any) => {
                            id = id + 1
                            elements.map((e: any) => {
                                if (c.next.type === "end") {
                                    if (e.data && e.data.type && (e.data.type === "stop" || e.data.type === "return")) {
                                        node = e.id;
                                    }
                                } else if (e.source === nodeDetail.id && e.sourceHandle === _.camelCase(c.name)) {
                                    const nextNode = elements.filter((el: any) => { return (e.target === el.id) })
                                    node = nextNode && nextNode[0].data && nextNode[0].data.propertyDetails && nextNode[0].data.propertyDetails.name || e.target;
                                }
                                return node
                            })
                            classification = {
                                ...classification,
                                id: _.camelCase(c.name),
                                description: c.description,
                                name: c.name,
                                linkNode: node,
                                blocks: true,
                                nameCheck: false,
                                expand: false,
                            }
                            node = "";
                            return classifierData.push(classification)
                        })
                        if (nodeDetail.data.propertyDetails.formKey) {
                            form && form.forEach((f: any) => {
                                if (f.formKey === nodeDetail.data.propertyDetails.formKey) {
                                    setSelectedForm(f.displayName)
                                }
                            })
                        }
                        if (classifierData) {
                            setRemoveValues(false)
                            setDisableExpand(false);
                            setEditEnable(false)
                            setAddClassifier(classifierData)
                            setShowCheckIcon(false)
                            setShowAddIcon(true)
                            setEventNameEmpty(false)
                        }
                    }
                }
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "aiClassifier") {
                setName(nodeDetail.id);
                setSelectedForm(null);
                setFormKey(null);
                setClassifierName(nodeDetail.id);
                setAddClassifier([{
                    id: "default",
                    expression: "true",
                    name: "Default",
                    linkNode: "",
                    blocks: true,
                    nameCheck: false,
                    expand: false
                }])
                setAddHandle(addHandle + 1);
                setShowAddIcon(true)
                setEditEnable(false)
                setEventNameEmpty(false)
                setRemoveValues(false)
                setshowEdit(true);
                setDisableExpand(false)
                setEditEnable(false)
                setllmConfiguration({
                    provider: "",
                    model: "",
                    config: {
                        topP: 1,
                        maxOutputTokens: 4000,
                        temperature: 1
                    }
                })
            }
        }
    }, [nodeDetail.id, widgetDrawer])

    useEffect(() => {
        if (form) {
            form.forEach((f: any) => {
                if (f.displayName === selectedForm) {
                    setFormKey(f.formKey)
                }
            })
        }
    }, [selectedForm])

    useEffect(() => {
        if (classifierName || name === "") {
            setClassifierProperty({
                nodeId: props.nodeDetail.id,
                inputQuery,
                classification: addClassifier,
                name: name,
                llm: { ...llmConfiguration },
                formKey,
                idChange: false,
                type: "aiClassifier"
            })
        }
    }, [classifierName, llmConfiguration, inputQuery, name, formKey])


    useEffect(() => {
        if (addClassifier.length > 0) {
            if (addClassifier.every((eL: any) => eL.expand === true)) {
                setExpandAll(true)
            } else {
                setExpandAll(false)
            }
        }
    }, [addClassifier])


    useEffect(() => {
        props.onUpdateProperties(classifierProperty)
    }, [classifierProperty])

    useEffect(() => {
        if (removeClassifier > 0) {
            setClassifierProperty({
                nodeId: nodeDetail.id,
                classification: addClassifier,
                inputQuery,
                name: name,
                idChange: true,
                formKey,
                removedLinkNode: removedLinkNode,
                handleId: handleId,
                llm: { ...llmConfiguration },
            })
        }
    }, [removeClassifier])

    useEffect(() => {
        if (addHandle > 0) {
            if (!updatedId) {
                setClassifierProperty({
                    nodeId: nodeDetail.id,
                    inputQuery,
                    classification: addClassifier,
                    name: name,
                    formKey,
                    idChange: true,
                    llm: { ...llmConfiguration },
                })
            } else if (updatedId) {
                setClassifierProperty({
                    nodeId: props.nodeDetail.id,
                    inputQuery,
                    classification: addClassifier,
                    name: name,
                    formKey,
                    idChange: true,
                    updatedId: updatedId && updatedId,
                    llm: { ...llmConfiguration },
                })
            }
        }
    }, [addHandle, llmConfiguration])

    const AddHandle = () => {
        const value = {
            id: "",
            expression: "",
            name: "",
            linkNode: "",
            blocks: false,
            nameCheck: false,
            expand: false
        }
        setAddClassifier((prevState: any) => [value, ...prevState]);
    }

    const handleSpace = (e: any) => {
        if (e.keyCode === 32 || e.keyCode === 8) {
            setSpaceKeyPressed(true)
        } else {
            setSpaceKeyPressed(false)
        }
    };

    const handleName = (e: any, Index: any) => {
        const { value } = e.target;
        setValue(value);
        const Names = addClassifier.map((el: any) => _.camelCase(el.name));
        setEventNameEmpty(false)
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...addClassifier]
                val[Index].nameCheck = true;
                val[Index].name = e.target.value;
                setAddClassifier(val)
                setShowCheckIcon(false)
            } else {
                const values = [...addClassifier];
                values[Index].name = e.target.value;
                values[Index].nameCheck = false;
                values[Index].id = _.camelCase(e.target.value)
                setAddClassifier(values);
            }
        } else {
            const values = [...addClassifier];
            values[Index].name = e.target.value;
            values[Index].nameCheck = false;
            values[Index].id = _.camelCase(e.target.value)
            setAddClassifier(values);
        }
    }


    const handleDescription = (e: any, Index: any) => {
        const { value } = e.target;
        setValue(value);
        const Names = addClassifier.map((el: any) => _.camelCase(el.name));
        setEventNameEmpty(false)
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...addClassifier]
                val[Index].nameCheck = true;
                val[Index].description = e.target.value;
                setAddClassifier(val)
                setShowCheckIcon(false)
            } else {
                const values = [...addClassifier];
                values[Index].description = e.target.value;
                values[Index].nameCheck = false;
                setAddClassifier(values);
            }
        } else {
            const values = [...addClassifier];
            values[Index].name = e.target.value;
            values[Index].nameCheck = false;
            values[Index].id = _.camelCase(e.target.value)
            setAddClassifier(values);
        }
    }

    const linkNode = (e: any, Index: any) => {
        const values = [...addClassifier];
        values[Index].linkNode = e;
        setAddClassifier(values);
    }


    const handleRemove = (i: any = null, id: any = null) => {
        if (i !== undefined && !id) {
            const values = [...addClassifier];
            values.splice(i, 1);
            setAddClassifier(values);
        } else if (i !== undefined && id) {
            addClassifier.forEach((c: any) => {
                if (c.id === id) {
                    setHandleId(c.id)
                    setRemovedLinkNode(c.linkNode)
                }
            })
            setAddClassifier((prevState: any) => prevState.filter((i: any) => { return i.id !== id }))
            setRemoveClassifier(removeClassifier + 1);
        }
    }

    const findhandleId = (i: any, id: any) => {
        let updatedId = addClassifier.filter((m: any) => {
            return (m.id === id);
        })
        updatedId && updatedId.map((i: any) => {
            return setUpdatedId(i.id)
        })
    }

    const renderClassifier = (index: number, element: any, blocks: any, expand: any) => {
        const checkSpecialCharacter = /[!@#$%^&*~`()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        return (
            <div key={index + 1} style={{ padding: "0 10px" }}>
                {!expand && blocks &&
                    <div className={style.collapsePanel} >
                        <div
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            {blocks && !props.lock && showaddIcon &&
                                <img
                                    className={element.name === "Default" ? "filtered" : "drag-handle"}
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => element.name !== "Default" && setToggleEnable(true)}
                                    src={element.name !== "Default" ? dragIcon : ""}
                                />}
                            <Tooltip title={element.name}>
                                <div className={style.panelName}>
                                    {element.name}
                                </div>
                            </Tooltip>
                        </div>
                        {!props.lock &&
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {!removeValues && !editEnable && showaddIcon && <Icon
                                    type="edit"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => {
                                        setAddClassifier(
                                            (classification: any) => classification.map((c: any) => {
                                                return c.id === element.id ? { ...element, blocks: false } : c
                                            }));
                                        findhandleId(index, element.id);
                                        setShowAddIcon(false)
                                        setShowCheckIcon(true)
                                        setshowEdit(false)
                                        setRemoveValues(true)
                                    }} />}
                                {element.name !== "Default" && showaddIcon && <Icon
                                    type="delete"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => handleRemove(index, element.id)}
                                ></Icon>}
                                {showaddIcon && <Icon
                                    style={{ fontSize: 15, marginRight: "10px" }}
                                    type="right"
                                    onClick={() => {
                                        setAddClassifier(
                                            (classification: any) => classification.map((c: any) => {
                                                return c.id === element.id ? { ...element, expand: true } : c
                                            }))

                                    }} >
                                </Icon>}
                            </div>}
                    </div>}

                {(!blocks || expand) &&
                    <div
                        style={{
                            border: (expand || expandAll || !showEdit) ? "1px solid #CAD5E9" : "",
                            background: (expand || expandAll || !showEdit) ? "#FFFFFF 0% 0% no-repeat padding-box" : "",
                            boxShadow: (expand || expandAll || !showEdit) && "0px 3px 14px #CAD5E983",
                            marginTop: "20px",
                            borderRadius: "5px"
                        }}>
                        {(expand || expandAll || !showEdit && !props.lock) &&
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                padding: (expand || expandAll || !showEdit) ? "0px 10px" : "0px 20px",
                                position: (expand || expandAll || !showEdit) && "relative",
                                marginTop: (expand || expandAll || !showEdit) && "10px"
                            }}>
                                {!props.lock && <img
                                    className="drag-handle"
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => showaddIcon && element.name !== "Default" && setToggleEnable(true)}
                                    src={element.name !== "Default" ? dragIcon : ""}
                                />}
                                {!props.lock && <div>
                                    {!removeValues && showaddIcon && <Icon
                                        type="edit"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => {
                                            setAddClassifier(
                                                (classification: any) => classification.map((c: any) => {
                                                    return c.id === element.id ? { ...element, blocks: false } : c
                                                }));
                                            findhandleId(index, element.id);
                                            setShowAddIcon(false)
                                            setShowCheckIcon(true)
                                            setshowEdit(false)
                                            setRemoveValues(true)
                                        }}
                                    />}
                                    {element.name !== "Default" && showaddIcon && <Icon
                                        type="delete"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => handleRemove(index, element.id)}
                                    ></Icon>}
                                    {<Icon
                                        style={{ fontSize: 15, marginRight: "10px" }}
                                        type="down"
                                        onClick={() => {
                                            setAddClassifier(
                                                (classification: any) => classification.map((c: any) => {
                                                    return c.id === element.id && showaddIcon ? { ...element, expand: false } : c
                                                }))
                                        }} >
                                    </Icon>}
                                </div>}
                            </div>}
                        <div
                            style={{
                                border: ((!expand && !expandAll && showEdit)) ? "1px dashed #0F66C8" : "",
                                borderRadius: "8px",
                                padding: (expand || !expandAll && showEdit) ? 10 : !showEdit ? 10 : 0,
                                margin: ((!expand || !expandAll) && !blocks) ? 5 : 0
                            }}>
                            <div
                                key={index}
                                className={style.conditionInput}
                                style={{
                                    borderBottom: (!expand || !expandAll) && blocks && "1px solid 000610",
                                    margin: !expand && blocks ? 13 : 0,
                                    height: "auto",
                                    padding: (expand || !expandAll) ? "0 10px" : "0 15px",
                                    boxSizing: "border-box",
                                }}>

                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Classification Name</label>
                                </div>
                                <Input
                                    onKeyDown={handleSpace}
                                    disabled={blocks || props.lock || element.name === "Default"}
                                    style={{
                                        width: "100%",
                                        outline: "none",
                                        height: "44px",
                                        color: "#000610",
                                        fontSize: 15,
                                        border: "1px solid #909BAD"
                                    }}
                                    placeholder="Enter classification name"
                                    value={element.name || ""}
                                    onChange={(e) => { !checkSpecialCharacter.test(e.target.value) && handleName(e, index) }}
                                />
                                {(element.nameCheck || eventNameEmpty) &&
                                    <p style={{
                                        color: "#FF0000",
                                        opacity: element.nameCheck || eventNameEmpty ? 1 : 0,
                                        position: "relative",
                                        top: '15px',
                                        textAlign: "center"
                                    }}>{eventNameEmpty ? "Name shouldn't be empty" : "Name already exist"}</p>}

                                {element.name !== "Default" && <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Description Name</label>
                                </div>}
                                {element.name !== "Default" && <Input
                                    onKeyDown={handleSpace}
                                    disabled={blocks || props.lock || element.name === "Default"}
                                    style={{
                                        width: "100%",
                                        outline: "none",
                                        height: "44px",
                                        color: "#000610",
                                        fontSize: 15,
                                        border: "1px solid #909BAD"
                                    }}
                                    placeholder="Enter description"
                                    value={element.description || ""}
                                    onChange={(e) => { handleDescription(e, index) }}
                                />}

                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Next Node</label>
                                </div>
                                <Select
                                    showSearch
                                    suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                    disabled={blocks || props.lock}
                                    value={element.linkNode || undefined}
                                    placeholder="Select next node"
                                    optionLabelProp="label"
                                    style={{
                                        width: "100%",
                                        borderRadius: 8,
                                        color: "#000610",
                                        fontSize: 15
                                    }}
                                    mode="default"
                                    size="large"
                                    onChange={(e: any) => { linkNode(e, index) }}
                                    filterOption={(input, option: any) => {
                                        return (option && option.props)
                                            ?
                                            option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            : false
                                    }}
                                >
                                    {nodes && nodes.map((el: any) => {
                                        return <Option
                                            key={el.id}
                                            value={el.id}
                                            label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                        >
                                            <div
                                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div
                                                    style={{ display: "flex", flexDirection: "row" }}>
                                                    <img alt="icons" src={el.data.icon} />
                                                    <p
                                                        style={{
                                                            marginLeft: "8px",
                                                            marginTop: "15px",
                                                            color: el.id === element.linkNode ? "#0F66C8" : "#000610"
                                                        }}
                                                    >
                                                        {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                                    </p>
                                                </div>
                                                {el.id === element.linkNode &&
                                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                                            </div>
                                        </Option>
                                    })}
                                </Select>
                                <div style={{ display: "flex", flexDirection: "row", marginTop: 15, justifyContent: "flex-end" }}>
                                    {!blocks && !props.lock &&
                                        <Button
                                            style={{ width: "30%", marginRight: showCheckIcon ? "15px" : "0px" }}
                                            onClick={() => {
                                                let findClassifier = nodeDetail?.data?.propertyDetails?.classifications ? nodeDetail?.data?.propertyDetails?.classifications : nodeDetail?.data?.propertyDetails?.classification
                                                showEdit ?
                                                    handleRemove(index, element.id && element.id) : element.id &&
                                                    setAddClassifier(findClassifier.map((c: any) => {
                                                        return { ...c, name: c.name || c.name, id: c.name || c.name, blocks: true }
                                                    }));
                                                // showEdit ?
                                                //     handleRemove(index, element.id && element.id) : element.id &&
                                                //     setAddClassifier((classification: any) => classification.map((c: any) => {
                                                //         return c.id.trim() === element.id.trim() ? { ...element, blocks: true } : c
                                                //     }));
                                                if (element.id) {
                                                    setShowCheckIcon(false);
                                                    setShowAddIcon(true)
                                                    setDisableExpand(false)
                                                    setshowEdit(true);
                                                    setEditEnable(false)
                                                    setRemoveValues(false);
                                                    setEventNameEmpty(false)
                                                } else if (showEdit) {
                                                    setShowCheckIcon(false);
                                                    setShowAddIcon(true)
                                                    setDisableExpand(false)
                                                    setshowEdit(true);
                                                    setEditEnable(false)
                                                    setRemoveValues(false);
                                                    setEventNameEmpty(false)
                                                } else {
                                                    setEventNameEmpty(true)
                                                }
                                            }}
                                        >CANCEL</Button>}
                                    {(!blocks && !props.nameCheck && !props.lock && !element.nameCheck && showCheckIcon) &&
                                        <Button
                                            style={{ width: "30%", border: "none", backgroundColor: "#51808c" }}
                                            type="primary"
                                            onClick={() => {
                                                setAddClassifier(
                                                    (classification: any) => {
                                                        const updatedClassifier = classification.map((c: any) => {
                                                            return c.id === element.id ? { ...element, blocks: true, expand: false } : c
                                                        })
                                                        if (updatedClassifier.length === 1) {
                                                            return updatedClassifier;
                                                        }
                                                        if (showEdit) {
                                                            const defaultCondtion = updatedClassifier.filter((classification: any) => { return (classification.name === "Default") })
                                                            const newUpdatedClassifier = updatedClassifier.filter((classification: any) => { return (classification.name !== "Default" && updatedClassifier[0].id !== classification.id) })
                                                            return [...newUpdatedClassifier, updatedClassifier[0], ...defaultCondtion]
                                                        } else {
                                                            return updatedClassifier
                                                        }
                                                    });
                                                setAddHandle(addHandle + 1);
                                                setShowAddIcon(true)
                                                setshowEdit(true);
                                                setDisableExpand(false)
                                                setEditEnable(false)
                                                if (showEdit) {
                                                    setUpdatedId(null)
                                                } else {
                                                    setRemoveValues(false)
                                                }
                                            }}
                                        >{showEdit ? "ADD" : "SAVE"}</Button>}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>)
    }

    useEffect(() => {
        setReactSortableKey(new Date().getTime());
        setSortableOptions({ ...sortableOptions, disabled: !toggle });
    }, [toggle]);

    return (
        <div style={{ height: window.innerHeight - 500 }}>
            <div className={style.conditionInput}>
                <div style={{ width: "100%" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                            Name
                        </label>
                    </div>

                    <Input
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                        }}
                        placeholder="Enter Node Name"
                        value={name}
                        disabled={props.lock}
                        onChange={(e: any) => { setClassifierName(e.target.value); setName(e.target.value); }}
                    />
                </div>
                {(props.nameCheck || !name) && <p style={{
                    color: "#FF0000",
                    opacity: props.nameCheck || !name ? 1 : 0,
                    position: "relative",
                    textAlign: "center",
                    margin: "5px",
                    fontSize: 14
                }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>

            <div style={{ background: "#909BAD26", height: 44, display: "flex", position: "relative", alignItems: "center", marginLeft: 15, marginRight: 15, padding: 10 }} >
                <span style={{ color: "#0F66C8", fontSize: 14, fontWeight: 600 }}>Configure LLM</span>

                <>
                    <img style={{ cursor: "pointer", height: 14, width: 14, position: "absolute", right: 15 }} src={openConfigIcon} onClick={() => { setOpenLLMConfig(!openLLMConfig) }} />
                    <Popover
                        className="service-type"
                        style={{left: 420}}
                        overlayClassName="overlay-service-type"
                        placement="left"
                        content={<LLMConfiguration setllmConfiguration={setllmConfiguration} llmConfiguration={llmConfiguration} setOpenLLMConfig={setOpenLLMConfig} lock={props.lock}/>}
                        visible={openLLMConfig}
                        trigger="hover"
                    />
                </>
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>

            <div className={style.conditionInput}>
                <div style={{ width: "100%" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                            Input Query
                        </label>
                    </div>

                    <Input
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                        }}
                        placeholder="eg: get_weather"
                        value={inputQuery}
                        disabled={props.lock}
                        onChange={(e: any) => { setInputQuery(e.target.value); }}
                    />
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px" }}>
                <div className={style.label} >
                    <label> Waiting Form Screen</label>
                </div>
                <Select
                    showSearch
                    suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                    disabled={props.lock}
                    placeholder="Select the form"
                    value={selectedForm || undefined}
                    size="large"
                    style={{
                        width: "100%",
                        borderRadius: 8,
                        //border: "1px solid #CAD5E9",
                        color: "#000610",
                        fontSize: 15,
                    }}
                    optionLabelProp="label"
                    onChange={(e: any) => setSelectedForm(e)}
                    filterOption={(input, option: any) => {
                        return (option && option.props && option.props.children) ?
                            option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                            : false
                    }}
                >
                    {form && form.map((item: any) => {
                        return <Option
                            key={item.formId}
                            value={item.displayName}
                            label={item.displayName}>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p style={{ marginTop: "10px", color: item.displayName === selectedForm ? "#0F66C8" : "#000610" }}>
                                    {item.displayName}
                                </p>
                                {item.displayName === selectedForm &&
                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                            </div>
                        </Option>
                    })}
                </Select>
            </div>

            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>

            <div style={{ display: "flex", justifyContent: "space-between", padding: "0px 10px" }}>
                {expandAll ?
                    <button
                        //disabled={!disableExpand}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 14px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && setAddClassifier((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: false
                            })))
                            !disableExpand && setExpandAll(false)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder" />
                        Collapse All
                    </button> :
                    <button
                        //disabled={}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 16px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && showaddIcon && setAddClassifier((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: true
                            })))
                            !disableExpand && showaddIcon && setExpandAll(true)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder-open" />
                        Expand All
                    </button>}
                <Button
                    style={{ borderRadius: 22, backgroundColor: "#51808c", color: "white", border: "none", outline: "none" }}
                    disabled={props.lock || !showaddIcon || expandAll || props.nameCheck}
                    // icon="folder-add"
                    onClick={() => {
                        if (!props.lock) {
                            AddHandle();
                            setShowCheckIcon(false);
                            setShowAddIcon(false);
                            setDisableExpand(true);
                            setEditEnable(true);
                        }
                    }}
                    type="primary"
                >Add Classification
                </Button>
            </div>
            <div
                style={{ overflow: "auto", maxHeight: "calc(-150px + 40vh)", border: "none", marginTop: "10px" }}>
                <ReactSortable list={addClassifier} key={reactSortableKey} setList={(state: any) => {
                    const defaultValue = state.filter((value: any) => { return (value.name === "Default") });
                    const other = state.filter((value: any) => { return (value.name !== "Default") })
                    setAddClassifier([...other, ...defaultValue])
                }} {...sortableOptions} onEnd={() => { setAddHandle(addHandle + 1) }}>
                    {addClassifier.map((element: any, index: any) => {
                        const { blocks, expand } = element
                        return (
                            renderClassifier(index, element, blocks, expand)
                        )
                    })}
                </ReactSortable>
            </div>
        </div >
    )
}
export default Classifier

const LLMConfiguration = ({ setllmConfiguration, llmConfiguration, setOpenLLMConfig, lock }: LlmProps) => {
    const modelsProvider = [
        { label: "OpenAI", value: "openai" },
        { label: "Gemini", value: "gemini" },
        { label: "Anthropic", value: "anthropic" },
        { label: "Uniphore", value: "uniphore" }
    ]
    const openAiModels = [{ label: "gpt-4-turbo", value: "gpt-4-turbo" }, { label: "gpt-4o", value: "gpt-4o" }, { label: "gpt-4o-mini", value: "gpt-4o-mini" }]
    const geminiModels = [{ label: "gemini-1.5-pro", value: "gemini-1.5-pro" }, { label: "gemini-1.5-flash", value: "gemini-1.5-flash" }]
    const claudeModels = [
        { label: "claude-3-5-sonnet", value: "claude-3-5-sonnet" },
        { label: "claude-3-5-opus", value: "claude-3-opus" },
        { label: "claude-3-5-haiku", value: "claude-3-haiku" },
    ]
    const uniphoreModels = [
        { label: "Facts-8b-SLM", value: "facts-8b-slm" },
        { label: "Summary-8b-SLM", value: "summary-8b-slm" },
        { label: "Chat-70b-LLM", value: "chat-70b-llm" }
    ]

    const modelsList = llmConfiguration.provider === "openai" ? openAiModels : llmConfiguration.provider === "gemini" ? geminiModels : llmConfiguration.provider === "anthropic" ? claudeModels : 
        llmConfiguration.provider === "uniphore" ? uniphoreModels : [];
    return (
        <div style={{ width: 354, borderRadius: 4, padding: 10, height: 356, display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row" }}>
                <span>Configure LLM</span>

                <div style={{ cursor: "pointer" }} onClick={() => {setOpenLLMConfig(false) }}>X</div>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center" }}>
                <div style={{ width: 150 }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                            Provider
                        </label>
                    </div>

                    <Select
                        disabled={lock}
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            color: "#000610",
                            fontSize: 15,
                        }}
                        mode="default"
                        size="large"
                        placeholder="Select Provider"
                        value={llmConfiguration.provider || undefined}
                        onChange={(e: string) => {
                            setllmConfiguration({
                                ...llmConfiguration,
                                provider: e,
                                model: ""
                            });
                        }}
                    >
                        {modelsProvider?.map((provider) => (
                            <Option key={provider.value} value={provider.value}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {provider.value === "openai" ?
                                        <GptLogo style={{ marginRight: 5 }} /> : provider.value === "gemini" ?
                                        <GeminiLogo style={{ marginRight: 5 }} /> : provider.value === "anthropic" ?
                                        <ClaudeLogo style={{marginRight: 5}}/> : 
                                        <UniphoreLogo style={{marginRight: 5, height: 18, width: 18}}/>
                                    } {provider.label}
                                </div>
                            </Option>
                        ))}
                    </Select>
                </div>
                <div style={{ width: 150 }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                            Model
                        </label>
                    </div>

                    <Select
                        disabled={lock}
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            color: "#000610",
                            fontSize: 15
                        }}
                        mode="default"
                        size="large"
                        placeholder="Select model"
                        value={llmConfiguration.model || undefined}
                        onChange={(e: any) => {
                            setllmConfiguration({
                                ...llmConfiguration,
                                model: e
                            });
                        }}
                    >
                        {modelsList.map((model) => {
                            return (
                                <Option key={model.value} value={model.value}>{model.label}</Option>
                            )
                        })}
                    </Select>
                </div>
            </div>


            <div style={{ border: "1px solid #7D84924D" }}></div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center" }}>
                <div style={{ width: 150 }}>
                    <Tooltip placement="top" title="Enter temperature value 0 - 2">
                    <div
                        className={style.label}
                            style={{ color: "#3c434a", marginBottom: 5, textDecoration: "underline dashed", textUnderlineOffset: 5 }}>
                        <label >
                            Temperature
                        </label>
                    </div>
                    </Tooltip>

                    <InputNumber
                        min={0}
                        max={1}
                        disabled={lock}
                        className="llm_number_input"
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: "1px solid #909BAD"
                        }}
                        type="number"
                        placeholder="Temperature"
                        value={llmConfiguration.config.temperature}
                        onChange={(e: any) => {
                            setllmConfiguration({
                                ...llmConfiguration,
                                config: {
                                    ...llmConfiguration.config,
                                    temperature: e
                                }
                            });
                        }}
                    />
                </div>
                <div style={{ width: 150 }}>
                    <Tooltip placement="top" title="Output token limit 1 - 8192">
                    <div
                        className={style.label}
                            style={{ color: "#3c434a", marginBottom: 5, textDecoration: "underline dashed", textUnderlineOffset: 5}}>
                        <label >
                            Output Token Limit
                        </label>
                    </div>
                    </Tooltip>

                    <InputNumber
                        disabled={lock}
                        className="llm_number_input"
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: "1px solid #909BAD"
                        }}
                        type="number"
                        placeholder="Ouput tokens"
                        value={llmConfiguration.config.maxOutputTokens}
                        onChange={(e: any) => {
                            setllmConfiguration({
                                ...llmConfiguration,
                                config: {
                                    ...llmConfiguration.config,
                                    maxOutputTokens: e
                                }
                            });
                        }}
                    />
                </div>
            </div>

            <>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: 10, alignItems: "center" }}>
                    <div style={{ width: 150 }}>
                        <Tooltip placement="top" title="Enter Top-P limit 0 - 1">
                        <div
                            className={style.label}
                            style={{ color: "#3c434a", marginBottom: 5, textDecoration: "underline dashed", textUnderlineOffset: 5 }}>
                            <label >
                                Top-P
                            </label>
                        </div>
                        </Tooltip>

                        <InputNumber
                            min={0}
                            max={2}
                            disabled={lock}
                            className="llm_number_input"
                            style={{
                                width: "100%",
                                height: "44px",
                                color: "#000610",
                                fontSize: 15,
                                border: "1px solid #909BAD"
                            }}
                            type="number"
                            placeholder="TopP"
                            value={llmConfiguration.config.topP}
                            onChange={(e: any) => {
                                setllmConfiguration({
                                    ...llmConfiguration,
                                    config: {
                                        ...llmConfiguration.config,
                                        topP: e
                                    }
                                });
                            }}
                        />
                    </div>
                    {/* <div style={{ width: 150 }}>
                        <div
                            className={style.label}
                            style={{ color: "#3c434a" }}>
                            <label >
                                Top-K
                            </label>
                        </div>

                        <InputNumber
                            className="llm_number_input"
                            style={{
                                width: "100%",
                                height: "44px",
                                color: "#000610",
                                fontSize: 15,
                                border: "1px solid #909BAD"
                            }}
                            type="number"
                            placeholder="TopP"
                            value={llmConfiguration.topK}
                            onChange={(e: any) => {
                                setllmConfiguration({
                                    ...llmConfiguration,
                                    topK: e.target.value
                                });
                            }}
                        />
                    </div> */}
                </div>
                {/* <div>
                    <button>Cancel</button>
                    <button>Apply</button>
                </div> */}
            </>
        </div>
    )
}